(function(){
'use strict';

/* ══════════════════════════════════════════════════════════════
   SETTINGS — everything a merchandiser can change without a deploy.
   Injected by sections/price-raise-simulator.liquid as PRS_CONFIG.
   Preset prices and volumes are ILLUSTRATIVE starting points chosen
   to make the math legible, not survey data; the page says so.
   ══════════════════════════════════════════════════════════════ */
var CFG = window.PRS_CONFIG || {};

/* Presets, typical-US anchors and the income-follow power all come from the
   section schema so copy and the two editorial numbers can change without a
   deploy. The literals below are the shipped defaults, not a second source. */
var CONFIG = {
  presets: (CFG.presets && CFG.presets.length) ? CFG.presets : [
    { key:'brazilian', name:'Brazilian',  price:65, volume:15, proposed:75, typicalUS:65 },
    { key:'brows',     name:'Brows',      price:25, volume:20, proposed:30, typicalUS:25 },
    { key:'underarms', name:'Underarms',  price:30, volume:10, proposed:35, typicalUS:30 },
    { key:'legs',      name:'Full legs',  price:80, volume:6,  proposed:90, typicalUS:80 }
  ],

  // Weeks per month (52 / 12). A constant of the calendar, not a setting.
  weeksPerMonth: 4.33,
  defaultTarget: CFG.defaultTarget || 6000,

  tieIn: CFG.tieIn || { line:'', linkText:'', linkUrl:'' },
  kit: CFG.kit || {},

  /* ── THE SECOND EDITORIAL NUMBER ─────────────────────────────
     How much price actually follows local income. NOT one-for-one:
     wax, strips and equipment cost the same everywhere, only rent
     and time flex. The income ratio is square-rooted (a half-
     elasticity) and clamped, which keeps both tails sane. Re-check
     BOTH tails after any change. The first number is typicalUS. */
  incomeFollow: { power:(CFG.incomeFollowPower != null ? Number(CFG.incomeFollowPower) : 0.5),
                  min:0.65, max:1.9 },

  datePlaceholder:'[date]'
};

/* ══════════════════════════════════════════════════════════════
   CENSUS — real data, and deliberately not a setting.

   Median household income by ZIP Code Tabulation Area.
   Source: U.S. Census Bureau, American Community Survey 2023
   5-year estimates, table B19013. Public domain.

   30,618 ZCTAs, fixed-width base36: 4 chars ZCTA + 3 chars income
   in hundreds of dollars, sorted ascending so it can be binary
   searched in place. ~3,150 further ZCTAs are suppressed by Census
   for small sample size and are simply absent.
   ══════════════════════════════════════════════════════════════ */
/* Census income lives in assets/prs-zip-income.js, loaded deferred BEFORE this
   file so window.PRS_ZIP is always present by the time anything here runs. The
   null guard is belt-and-braces: if the asset ever fails, every ZIP falls
   through to the "we don't have income for that ZIP" state instead of throwing. */
function census(){ return window.PRS_ZIP || null; }

/* Binary search the fixed-width blob. Dollars, or null when Census
   publishes no median for that ZCTA. */
function lookupZip(zip){
  var C=census();
  if(!C||!C.blob) return null;
  var target=parseInt(zip,10);
  if(!isFinite(target)) return null;
  var lo=0, hi=C.n-1;
  while(lo<=hi){
    var mid=(lo+hi)>>1, off=mid*C.rec;
    var z=parseInt(C.blob.substr(off,4),36);
    if(z===target) return parseInt(C.blob.substr(off+4,3),36)*100;
    if(z<target) lo=mid+1; else hi=mid-1;
  }
  return null;
}

var W = CONFIG.weeksPerMonth;

var state = {
  tab:1,
  presetKey:CONFIG.presets[0].key,
  presets:JSON.parse(JSON.stringify(CONFIG.presets)),
  loss:0, submitted:false, email:'', emailErr:'',
  sending:false, emailed:false, sendNote:'',
  t2Dirty:{current:false, volume:false},
  chart:null
};

var ROOT = document.getElementById('prs-root');
if(!ROOT) return;
function $(s){ return ROOT.querySelector(s); }
function esc(s){
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
                  .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function num(v){
  if(v===null||v===undefined) return NaN;
  var t=String(v).replace(/[$,\s]/g,'');
  if(t==='') return NaN;
  var n=Number(t);
  return isFinite(n)?n:NaN;
}
function ok(n){ return isFinite(n) && n>0; }
function money(n){ return '$'+Math.round(n).toLocaleString('en-US'); }
function money2(n){ return '$'+n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
function pct1(n){ return (Math.round(n*10)/10).toFixed(1)+'%'; }
/* same rounding, drops a trailing ".0" — for scale ends and the live
   readout. Break-even always uses pct1 so it keeps its one decimal. */
function pctLoose(n){
  var r=Math.round(n*10)/10;
  return (r===Math.round(r)?String(Math.round(r)):r.toFixed(1))+'%';
}
function dec2(n){ return (Math.round(n*100)/100).toFixed(2); }
var MINUS='−';

/* Weekly when it rounds to 2+, monthly otherwise. Never prints
   "0.8 clients" or "0 a month". */
function bodies(fraction, volume){
  var perWeek=fraction*volume;
  if(perWeek>=1.5) return 'about '+Math.round(perWeek)+' a week';
  var r=Math.round(perWeek*W);
  if(r<1) return 'under one a month';
  return 'about '+r+' a month';
}

function currentPreset(){
  for(var i=0;i<state.presets.length;i++) if(state.presets[i].key===state.presetKey) return state.presets[i];
  return state.presets[0];
}

/* ══ TAB 1 MATH ══════════════════════════════════════════════ */
function computeT1(){
  var cur=num($('#f-current').value), vol=num($('#f-volume').value), prop=num($('#f-proposed').value);
  var c={cur:cur,vol:vol,prop:prop,okCur:ok(cur),okVol:ok(vol),okProp:ok(prop)};
  c.ready=c.okCur&&c.okVol&&c.okProp;
  if(!c.ready){ c.sliderMax=30; return c; }
  c.todayMonthly=cur*vol*W;
  c.newAtFull=prop*vol*W;
  c.mode= prop>cur ? 'raise' : (prop===cur ? 'same' : 'cut');
  c.breakEven=1-cur/prop;
  c.bePct=c.breakEven*100;
  c.sliderMax=Math.max(30, Math.ceil((c.bePct+10)*10)/10);
  c.upside=c.newAtFull-c.todayMonthly;
  c.needMore=cur/prop-1;
  return c;
}
function monthlyAtLoss(c,L){ return c.prop*c.vol*(1-L/100)*W; }

/* ══ TAB 2 MATH ══════════════════════════════════════════════ */
function computeT2(){
  var cur=num($('#f-t2current').value), vol=num($('#f-t2volume').value), tgt=num($('#f-target').value);
  var c={cur:cur,vol:vol,tgt:tgt,okCur:ok(cur),okVol:ok(vol),okTgt:ok(tgt)};
  c.ready=c.okCur&&c.okVol&&c.okTgt;
  if(!c.ready) return c;
  c.currentMonthly=cur*vol*W;
  c.needPrice=tgt/(vol*W);
  c.extraExact=(tgt-c.currentMonthly)/(cur*W);
  c.extraCeil=Math.ceil(c.extraExact);
  c.alreadyThere= tgt<=c.currentMonthly;
  c.surplus=c.currentMonthly-tgt;
  return c;
}

/* ══ AREA INCOME ═════════════════════════════════════════════
   No pricing dataset exists for independent waxing, so this does
   not pretend to be one. It re-expresses HER price against what
   households in her clients' ZIP actually earn.

   The single assumption, stated on the page: a service priced at
   the same share of local household income is "equivalently"
   priced — the same logic as any cost-of-living adjustment.
   Everything else is Census fact or her own input. No invented
   elasticity, no fabricated market rate.                          */
function computeMarket(){
  var raw=$('#f-area').value.trim();
  if(!raw) return {asked:false};
  var mm=raw.match(/\b\d{5}\b/);
  if(!mm) return {asked:true,found:false,reason:'format'};
  var zip=mm[0], inc=lookupZip(zip);
  if(inc===null) return {asked:true,found:false,reason:'missing',zip:zip};

  var p=currentPreset(), base=Number(p.typicalUS)||p.price;
  var C=census();
  var index=inc/(C&&C.nationalMedian?C.nationalMedian:78538);
  var f=CONFIG.incomeFollow;
  var factor=Math.min(f.max, Math.max(f.min, Math.pow(index, f.power)));
  var typical=base*factor;
  return { asked:true, found:true, zip:zip, income:inc, index:index, factor:factor,
           service:p.name, typical:typical, low:typical*0.85, high:typical*1.15 };
}

/* Where a price sits against that range. Three states, because three
   is what she actually has to act on: under, about right, over. */
function pricePos(price,m){
  if(!ok(price)||!m||!m.found) return null;
  if(price<m.low) return 'below';
  if(price>m.high) return 'above';
  return 'normal';
}

function renderMarket(c){
  var host=$('#mkt-result'), m=computeMarket();
  $('#mkt-clear').hidden=!m.asked;
  if(!m.asked){ host.innerHTML=''; return m; }

  if(!m.found){
    host.innerHTML='<p class="mktmiss">'+(m.reason==='format'
      ? 'That needs to be a 5-digit ZIP code.'
      : 'We don’t have income for ZIP '+esc(m.zip)+'. It’s too small for the Census to report. '
        +'Try a nearby ZIP your clients also come from.')+'</p>';
    return m;
  }

  var h='<div class="mktcard">';
  var earn = m.index>=1.1 ? 'more than most of the US'
           : m.index<=0.9 ? 'less than most of the US'
           : 'about the same as most of the US';
  h+='<p class="mktearn">Homes near ZIP '+esc(m.zip)+' earn about <b>'+money(m.income)
    +'</b> a year. That’s '+earn+'.</p>';

  h+='<div class="mktnormal">'
    +'<span class="plbl">The range for your area</span>'
    +'<span class="mktrange num">'+money(m.low)+' – '+money(m.high)+'</span>'
    +'<span class="mktfor">for '+esc(m.service)+'</span></div>';

  /* Position bar. The range as a number answers "what is it"; this answers
     "where am I in it". Pins sit above and below the bar so they can never
     collide when the two prices are close together. */
  var vals=[m.low,m.high];
  if(ok(c.cur)) vals.push(c.cur);
  if(ok(c.prop)) vals.push(c.prop);
  var lo=Math.min.apply(null,vals), hi=Math.max.apply(null,vals);
  var pad=Math.max((hi-lo)*0.14,4), sMin=lo-pad, sMax=hi+pad;
  var X=function(v){ return ((v-sMin)/(sMax-sMin))*100; };

  h+='<div class="mktscale">';
  h+='<div class="mktband" style="left:'+X(m.low)+'%;width:'+(X(m.high)-X(m.low))+'%"></div>';
  h+='<div class="mkttypical" style="left:'+X(m.typical)+'%"></div>';
  if(ok(c.prop)&&c.prop!==c.cur)
    h+='<div class="mktpin pin-new" style="left:'+X(c.prop)+'%"><s>if you raise</s><b>'+money(c.prop)+'</b><i></i></div>';
  if(ok(c.cur))
    h+='<div class="mktpin pin-now" style="left:'+X(c.cur)+'%"><s>you now</s><b>'+money(c.cur)+'</b><i></i></div>';
  h+='</div>';
  h+='<div class="mktends"><span>'+money(m.low)+' low</span><span>'+money(m.high)+' high</span></div>';
  h+='<p class="mktlegend">The shaded part is the range. The line in the middle is '+money(m.typical)+'.</p>';

  /* The "you charge X, which sits inside that range" sentences used to run here,
     with posWords() supplying the phrasing. Both removed 11 Aug 2026: the position
     bar already shows where each price falls and the flag below states the verdict,
     so the prose was the same fact a third time. pricePos() stays — it drives the
     flag and the kit's announcement/value-framing switch. Anything reinstated here
     must still never say what other salons charge (contract E3). */
  var nowP=pricePos(c.cur,m), newP=pricePos(c.prop,m);

  var judge=newP||nowP, at=money(ok(c.prop)?c.prop:c.cur);
  if(judge==='below'){
    h+='<div class="mktflag good"><b>You have room.</b><p>Even at '+at
      +' you’d still sit under the low end.</p></div>';
  } else if(judge==='above'){
    h+='<div class="mktflag"><b>You’d be above the range.</b><p>That’s fine. You just need '
      +'to be able to say why. Your kit below has swapped to scripts for that.</p></div>';
  } else if(judge){
    h+='<div class="mktflag mid"><b>That fits your area.</b><p>'+at
      +' sits comfortably inside the range.</p></div>';
  }

  h+='<p class="mktsource">How we got this: what '+esc(m.service)+' usually costs across the US, '
    +'adjusted for what homes near you earn. It’s a guide, not a survey of other salons. '
    +'Income from the US Census.</p></div>';
  host.innerHTML=h;
  return m;
}

/* ══ PRESETS ═════════════════════════════════════════════════ */
function renderChips(){
  var active=document.activeElement;
  var focusedKey=(active&&active.getAttribute)?active.getAttribute('data-preset'):null;
  var html='';
  for(var i=0;i<state.presets.length;i++){
    var p=state.presets[i], on=p.key===state.presetKey;
    html+='<button class="chip" type="button" data-preset="'+esc(p.key)+'" aria-pressed="'+(on?'true':'false')+'">'
      +esc(p.name)+'<span class="cp num">$'+p.price+' → $'+p.proposed+'</span></button>';
  }
  $('#chips').innerHTML=html;
  if(focusedKey){
    var back=$('#chips').querySelector('[data-preset="'+focusedKey+'"]');
    if(back) back.focus();
  }
}
function applyPreset(key){
  state.presetKey=key;
  var p=currentPreset();
  $('#f-current').value=String(p.price);
  $('#f-volume').value=String(p.volume);
  $('#f-proposed').value=String(p.proposed);
  $('#f-t2current').value=String(p.price);
  $('#f-t2volume').value=String(p.volume);
  state.t2Dirty.current=false; state.t2Dirty.volume=false;
  state.loss=0; $('#loss').value='0';
  renderAll();
}

/* ══ TAB 1 RENDER ════════════════════════════════════════════ */
function renderT1(){
  var c=computeT1();
  $('#h-current').textContent  = (($('#f-current').value.trim()==='')||!c.okCur)  ? 'Pop in what you charge today.' : '';
  $('#h-volume').textContent   = (($('#f-volume').value.trim()==='')||!c.okVol)   ? 'How many of these do you do in a week?' : '';
  $('#h-proposed').textContent = (($('#f-proposed').value.trim()==='')||!c.okProp)? 'And what are you thinking of charging?' : '';

  var eyebrow, line, sub;
  if(!c.ready){
    eyebrow='The verdict';
    line='Fill in the three numbers above and I’ll do the scary part.';
    sub='Nothing gets sent anywhere. It’s just arithmetic on your own numbers.';
  } else if(c.mode==='raise'){
    eyebrow='If you go '+money(c.cur)+' → '+money(c.prop);
    // PRECISION: at exactly bePct she breaks even, she is not ahead.
    line='You could lose <b>'+pct1(c.bePct)+'</b> of your clients ('+bodies(c.breakEven,c.vol)
      +') and still make the same money you make today. Lose fewer than that and you’re up to <b>'
      +money(c.upside)+'/month</b> better off.';
    sub='Where '+pct1(c.bePct)+' comes from: divide '+money(c.cur)+' by '+money(c.prop)
      +', then take that off 100%. Lose more than '+pct1(c.bePct)
      +' and the raise costs you money. Lose less and you’re up.';
  } else if(c.mode==='same'){
    eyebrow='Same price either way';
    line='<b>'+money(c.cur)+'</b> in, <b>'+money(c.cur)+'</b> out. That’s the price you already charge.';
    sub='Nudge the second number up and the math gets interesting. At '+money(c.cur)+' × '+c.vol
      +' a week you’re at '+money(c.todayMonthly)+'/month.';
  } else {
    eyebrow=money(c.cur)+' → '+money(c.prop)+' · that’s a cut';
    line='At the number you do now, that cut costs you <b>'+money(Math.abs(c.upside))
      +'/month</b>. You’d need <b>'+pct1(c.needMore*100)+'</b> more clients ('
      +bodies(c.needMore,c.vol)+') just to get back to where you are today.';
    sub='Sometimes that’s the plan: a lower price to fill a quiet column. The math just tells you what it has to fill.';
  }
  $('#v-eyebrow').textContent=eyebrow;
  $('#v-line').innerHTML=line;
  $('#v-sub').textContent=sub;

  var slider=$('#loss');
  slider.max=String(c.sliderMax);
  if(state.loss>c.sliderMax) state.loss=c.sliderMax;
  slider.value=String(state.loss);
  $('#s-max').textContent=pctLoose(c.sliderMax);

  /* Track tint flips exactly at break-even. A cut or a no-change has no
     point at which you're ahead, so the whole track reads as "behind". */
  var hasBE=c.ready&&c.bePct>0&&c.bePct<=c.sliderMax;
  var beFrac=hasBE?(c.bePct/c.sliderMax):(c.ready&&c.mode!=='raise'?0:1);
  slider.style.setProperty('--be-frac',String(beFrac));
  var tick=$('#betick');
  tick.style.setProperty('--be-frac',String(beFrac));
  tick.hidden=!hasBE;

  updateSlider(c);
  drawChart(c);
  renderMarket(c);
  renderMath1(c);
  return c;
}

/* Same-frame slider update: synchronous DOM writes, no debounce, no tween. */
function updateSlider(c){
  c=c||computeT1();
  var L=state.loss;
  $('#s-pct').textContent=pctLoose(L);
  var box=$('#s-delta'), n=$('#s-deltanum'), st=$('#s-state'), slider=$('#loss');

  if(!c.ready){
    box.className='delta is-flat';
    n.textContent='—'; st.textContent='Waiting';
    $('#s-detail').textContent='';
    slider.setAttribute('aria-valuetext',pctLoose(L)+' of your clients leave. Add your numbers to see the effect.');
    moveChartPos(null);
    return;
  }
  var nowM=monthlyAtLoss(c,L), d=nowM-c.todayMonthly, r=Math.round(d);
  if(r>0){ box.className='delta is-gain'; n.textContent='+'+money(d); st.textContent='↑ Ahead'; }
  else if(r<0){ box.className='delta is-loss'; n.textContent=MINUS+money(Math.abs(d)); st.textContent='↓ Behind'; }
  else { box.className='delta is-flat'; n.textContent=money(0); st.textContent='Even'; }

  $('#s-detail').textContent='At '+pctLoose(L)+' loss you’d be doing about '
    +(Math.round(c.vol*(1-L/100)*10)/10)+' a week at '+money(c.prop)+' — '+money(nowM)
    +'/month, against '+money(c.todayMonthly)+'/month today.';

  slider.setAttribute('aria-valuetext', pctLoose(L)+' of your clients leave. '
    +(r>0?money(d)+' more':r<0?money(Math.abs(d))+' less':'the same')+' per month than today.');
  moveChartPos(L);
}

/* ══ CHART ═══════════════════════════════════════════════════ */
function drawChart(c){
  var host=$('#chart');
  var Wd=Math.max(240,Math.round(host.clientWidth||320));
  var H=Wd<420?178:210;
  var PL=56,PR=12,PT=30,PB=40;
  var iw=Wd-PL-PR, ih=H-PT-PB;
  var s=[];
  s.push('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+Wd+' '+H+'" width="'+Wd+'" height="'+H+'" aria-hidden="true" focusable="false">');
  s.push('<text x="0" y="11" font-size="9.5" font-weight="800" letter-spacing="1.3" fill="var(--muted)">MONEY IN PER MONTH</text>');

  if(!c.ready){
    s.push('<rect x="'+PL+'" y="'+PT+'" width="'+iw+'" height="'+ih+'" fill="var(--sunk)" stroke="var(--line)" rx="6"/>');
    s.push('<text x="'+(PL+iw/2)+'" y="'+(PT+ih/2+4)+'" text-anchor="middle" font-size="12" fill="var(--muted)">Add your numbers above</text>');
    s.push('<text x="'+PL+'" y="'+(H-14)+'" font-size="9.5" font-weight="800" letter-spacing="1.3" fill="var(--muted)">IF THIS MANY LEAVE →</text>');
    s.push('</svg>');
    host.innerHTML=s.join('');
    state.chart=null;
    $('#chart-sr').textContent='Chart unavailable until all three numbers are filled in.';
    return;
  }

  var maxPP=c.sliderMax;
  var n0=monthlyAtLoss(c,0), n1=monthlyAtLoss(c,maxPP), ty0=c.todayMonthly;
  var lo=Math.min(n0,n1,ty0), hi=Math.max(n0,n1,ty0);
  var pad=Math.max((hi-lo)*0.30, hi*0.03, 1);
  var yMin=Math.max(0,lo-pad), yMax=hi+pad;
  var X=function(pp){ return PL+(pp/maxPP)*iw; };
  var Y=function(v){ return PT+ih-((v-yMin)/(yMax-yMin))*ih; };
  var yToday=Y(ty0), yN0=Y(n0), yN1=Y(n1), xL=PL, xR=PL+iw;

  s.push('<rect x="'+PL+'" y="'+PT+'" width="'+iw+'" height="'+ih+'" fill="var(--sunk)" rx="6"/>');
  s.push('<line x1="'+PL+'" y1="'+PT+'" x2="'+xR+'" y2="'+PT+'" stroke="var(--grid)"/>');
  s.push('<line x1="'+PL+'" y1="'+(PT+ih)+'" x2="'+xR+'" y2="'+(PT+ih)+'" stroke="var(--grid)"/>');
  s.push('<text x="'+(PL-8)+'" y="'+(PT+4)+'" text-anchor="end" font-size="10.5" font-weight="600" fill="var(--muted)" style="font-variant-numeric:tabular-nums">'+money(yMax)+'</text>');
  s.push('<text x="'+(PL-8)+'" y="'+(PT+ih+4)+'" text-anchor="end" font-size="10.5" font-weight="600" fill="var(--muted)" style="font-variant-numeric:tabular-nums">'+money(yMin)+'</text>');

  var hasCross=c.bePct>0&&c.bePct<=maxPP;
  var bx=hasCross?X(c.bePct):null;
  if(hasCross){
    if(bx>xL+0.5) s.push('<path d="M'+xL+' '+yToday+' L'+xL+' '+yN0+' L'+bx+' '+yToday+' Z" fill="var(--gain-fill)"/>');
    s.push('<path d="M'+bx+' '+yToday+' L'+xR+' '+yN1+' L'+xR+' '+yToday+' Z" fill="var(--loss-fill)"/>');
  } else {
    var tone=(n0>=ty0)?'var(--gain-fill)':'var(--loss-fill)';
    s.push('<path d="M'+xL+' '+yToday+' L'+xL+' '+yN0+' L'+xR+' '+yN1+' L'+xR+' '+yToday+' Z" fill="'+tone+'"/>');
  }
  s.push('<line x1="'+xL+'" y1="'+yToday+'" x2="'+xR+'" y2="'+yToday+'" stroke="var(--muted)" stroke-width="2" stroke-dasharray="5 4"/>');
  s.push('<text x="'+(xL+6)+'" y="'+(yToday+(yN0<yToday?15:-7))+'" font-size="10.5" font-weight="800" fill="var(--muted)" style="font-variant-numeric:tabular-nums">today '+money(ty0)+'</text>');
  s.push('<line x1="'+xL+'" y1="'+yN0+'" x2="'+xR+'" y2="'+yN1+'" stroke="var(--ink)" stroke-width="2.6" stroke-linecap="round"/>');

  if(hasCross){
    s.push('<line x1="'+bx+'" y1="'+PT+'" x2="'+bx+'" y2="'+(PT+ih)+'" stroke="var(--ink)" stroke-width="1.5" stroke-dasharray="3 3" opacity=".75"/>');
    var label='BREAK-EVEN '+pct1(c.bePct);
    var lw=label.length*6.0+14, anchor='middle', lx=bx;
    if(bx>xR-lw/2){ anchor='end'; lx=xR; } else if(bx<xL+lw/2){ anchor='start'; lx=xL; }
    var rx=anchor==='middle'?lx-lw/2:(anchor==='end'?lx-lw:lx);
    s.push('<rect x="'+rx+'" y="'+(PT+3)+'" width="'+lw+'" height="16" rx="4" fill="var(--card)" stroke="var(--line)"/>');
    s.push('<text x="'+(rx+lw/2)+'" y="'+(PT+14.5)+'" text-anchor="middle" font-size="8.5" font-weight="800" letter-spacing="1" fill="var(--ink)">'+label+'</text>');
    s.push('<circle cx="'+bx+'" cy="'+yToday+'" r="5.5" fill="var(--ink)" stroke="var(--card)" stroke-width="2"/>');
  }
  s.push('<line id="posLine" x1="'+xL+'" y1="'+PT+'" x2="'+xL+'" y2="'+(PT+ih)+'" stroke="var(--ink)" stroke-width="1.5" opacity=".35"/>');
  s.push('<circle id="posDot" cx="'+xL+'" cy="'+yN0+'" r="4.5" fill="var(--brand-pink)" stroke="var(--ink)" stroke-width="1.5"/>');
  s.push('<text x="'+PL+'" y="'+(H-22)+'" font-size="10.5" font-weight="600" fill="var(--muted)">0%</text>');
  s.push('<text x="'+xR+'" y="'+(H-22)+'" text-anchor="end" font-size="10.5" font-weight="600" fill="var(--muted)" style="font-variant-numeric:tabular-nums">'+pctLoose(maxPP)+'</text>');
  s.push('<text x="'+(PL+iw/2)+'" y="'+(H-6)+'" text-anchor="middle" font-size="9.5" font-weight="800" letter-spacing="1.3" fill="var(--muted)">IF THIS MANY LEAVE →</text>');
  s.push('</svg>');
  host.innerHTML=s.join('');
  state.chart={X:X,Y:Y,c:c};

  var sr='Chart. Horizontal axis: how many of your clients leave, 0% to '+pctLoose(maxPP)
    +'. Vertical axis: money in per month. A flat dashed line marks today at '+money(ty0)
    +' a month. A declining line shows what you take in at '+money(c.prop)+' as clients leave, from '
    +money(n0)+' down to '+money(n1)+'. ';
  if(hasCross){
    sr+='The two lines cross at '+pct1(c.bePct)+' loss, the break-even point. You could lose up to '
      +pct1(c.bePct)+' of your clients — '+bodies(c.breakEven,c.vol)
      +' — and still come out ahead, and up to '+money(c.upside)+' a month better off if nobody leaves.';
  } else if(c.mode==='cut'){
    sr+='The lines never cross: the new price is below today’s, so the new line stays under the flat line across the whole range.';
  } else {
    sr+='The lines start together because the price has not changed.';
  }
  $('#chart-sr').textContent=sr;
  moveChartPos(state.loss);
}
function moveChartPos(L){
  var ch=state.chart;
  var line=ROOT.querySelector('#posLine'), dot=ROOT.querySelector('#posDot');
  if(!ch||!line||!dot||L===null) return;
  var x=ch.X(L);
  line.setAttribute('x1',x); line.setAttribute('x2',x);
  dot.setAttribute('cx',x);
  dot.setAttribute('cy',ch.Y(monthlyAtLoss(ch.c,L)));
}

/* ══ MATH PANELS ═════════════════════════════════════════════ */
function renderMath1(c){
  var el=$('#math-1');
  if(!c.ready){
    el.innerHTML='<span class="r">monthly = price × clients a week × '+W+'</span>'
      +'<span class="r k">'+W+' = 52 weeks ÷ 12 months</span>'
      +'<span class="note">Fill in the three numbers above and this fills in with yours.</span>';
    return;
  }
  var h='';
  h+='<span class="r">monthly = price × clients a week × '+W+'</span>';
  h+='<span class="r k">'+W+' = 52 weeks ÷ 12 months</span><hr>';
  h+='<span class="r">today   '+money(c.cur)+' × '+c.vol+' × '+W+'</span>';
  h+='<span class="r">        = '+money(c.todayMonthly)+'<span class="k">  ('+money2(c.todayMonthly)+')</span></span>';
  h+='<span class="r">new     '+money(c.prop)+' × '+c.vol+' × '+W+'</span>';
  h+='<span class="r">        = '+money(c.newAtFull)+'<span class="k">  ('+money2(c.newAtFull)+')</span></span>';
  h+='<span class="r">change  '+(c.upside>=0?'+':MINUS)+money(Math.abs(c.upside))
    +' / month<span class="k">  ('+money2(Math.abs(c.upside))+')</span></span><hr>';
  if(c.mode==='raise'){
    h+='<span class="r">most you can lose = 1 − ('+c.cur+' ÷ '+c.prop+') = '+pct1(c.bePct)+'</span>';
    h+='<span class="r">'+pct1(c.bePct)+' × '+c.vol+' a week = '+dec2(c.breakEven*c.vol)+' clients</span>';
    h+='<span class="r k">→ '+bodies(c.breakEven,c.vol)+'</span>';
  } else if(c.mode==='cut'){
    h+='<span class="r">clients needed = ('+c.cur+' ÷ '+c.prop+') − 1 = '+pct1(c.needMore*100)+' more</span>';
    h+='<span class="r">'+pct1(c.needMore*100)+' × '+c.vol+' a week = '+dec2(c.needMore*c.vol)+' clients</span>';
    h+='<span class="r k">→ '+bodies(c.needMore,c.vol)+'</span>';
  } else {
    h+='<span class="r">most you can lose = 1 − ('+c.cur+' ÷ '+c.prop+') = 0.0%</span>';
    h+='<span class="r k">nothing changes, so there’s nothing to break even on</span>';
  }
  var mk=computeMarket();
  if(mk.found){
    h+='<hr>';
    h+='<span class="r">normal near you</span>';
    h+='<span class="r">  '+money(Number(currentPreset().typicalUS)||currentPreset().price)+' usual US price</span>';
    h+='<span class="r">  local income is '+(Math.round(mk.index*100)/100)+'× the US median</span>';
    h+='<span class="r">  price follows about half of that: ×'+(Math.round(mk.factor*100)/100)+'</span>';
    h+='<span class="r">  = '+money(mk.typical)+'</span>';
    h+='<span class="r k">  range shown is that ±15%</span>';
  }
  h+='<span class="note">Calculations run on unrounded values; dollar figures on screen are rounded to the nearest whole dollar.</span>';
  el.innerHTML=h;
}
function renderMath2(c){
  var el=$('#math-2');
  if(!c.ready){
    el.innerHTML='<span class="r">monthly = price × clients a week × '+W+'</span>'
      +'<span class="r k">'+W+' = 52 weeks ÷ 12 months</span>'
      +'<span class="note">Fill in the numbers above and this fills in with yours.</span>';
    return;
  }
  var h='';
  h+='<span class="r">monthly = price × clients a week × '+W+'</span>';
  h+='<span class="r k">'+W+' = 52 weeks ÷ 12 months</span><hr>';
  h+='<span class="r">today   '+money(c.cur)+' × '+c.vol+' × '+W+'</span>';
  h+='<span class="r">        = '+money(c.currentMonthly)+'<span class="k">  ('+money2(c.currentMonthly)+')</span></span>';
  h+='<span class="r">target  '+money(c.tgt)+'</span><hr>';
  if(c.alreadyThere){
    h+='<span class="r">'+money(c.currentMonthly)+' − '+money(c.tgt)+'</span>';
    h+='<span class="r">        = '+money(c.surplus)+' over target</span>';
    h+='<span class="r k">already covered — no change needed</span>';
  } else {
    h+='<span class="r">(a) price at '+c.vol+' a week</span>';
    h+='<span class="r">    '+money(c.tgt)+' ÷ ('+c.vol+' × '+W+')</span>';
    h+='<span class="r">    = '+money2(c.needPrice)+'</span>';
    h+='<span class="r">(b) extra clients at '+money(c.cur)+'</span>';
    h+='<span class="r">    ('+money(c.tgt)+' − '+money2(c.currentMonthly)+')</span>';
    h+='<span class="r">      ÷ ('+c.cur+' × '+W+')</span>';
    h+='<span class="r">    = '+dec2(c.extraExact)+' a week → '+c.extraCeil+' <span class="k">(rounded up)</span></span>';
  }
  h+='<span class="note">Calculations run on unrounded values; dollar figures on screen are rounded to the nearest whole dollar, except the target price, which keeps its cents.</span>';
  el.innerHTML=h;
}

/* ══ TAB 2 RENDER ════════════════════════════════════════════ */
function renderT2(){
  if(!state.t2Dirty.current && document.activeElement!==$('#f-t2current')) $('#f-t2current').value=$('#f-current').value;
  if(!state.t2Dirty.volume  && document.activeElement!==$('#f-t2volume'))  $('#f-t2volume').value=$('#f-volume').value;
  // Default state says nothing — inheritance is invisible when it just works.
  // The control only appears once she has actually overridden a value.
  $('#i-t2current').innerHTML = state.t2Dirty.current
    ? 'Your override. <button type="button" data-reinherit="current">Use the Tab 1 value</button>' : '';
  $('#i-t2volume').innerHTML = state.t2Dirty.volume
    ? 'Your override. <button type="button" data-reinherit="volume">Use the Tab 1 value</button>' : '';

  var c=computeT2();
  $('#h-t2current').textContent=(($('#f-t2current').value.trim()==='')||!c.okCur)?'Pop in what you charge today.':'';
  $('#h-t2volume').textContent =(($('#f-t2volume').value.trim()==='') ||!c.okVol)?'How many of these do you do in a week?':'';
  $('#h-target').textContent   =(($('#f-target').value.trim()==='')   ||!c.okTgt)?'Put a number on it — what do you want the month to look like?':'';

  var box=$('#t2-results');
  if(!c.ready){
    box.innerHTML='<div class="alreadythere"><div class="at-h">Name your number</div>'
      +'<p>Tell it what you want the month to look like and it’ll show you both roads: charge more, or wax more.</p></div>';
  } else if(c.alreadyThere){
    box.innerHTML='<div class="alreadythere"><div class="at-h">You’re already there.</div>'
      +'<p>At '+money(c.cur)+' a service and '+c.vol+' a week, you’re bringing in about <strong>'
      +money(c.currentMonthly)+'</strong> a month — '
      +(c.surplus<0.5?'right on your '+money(c.tgt)+' target.':money(c.surplus)+' past your '+money(c.tgt)+' target.')
      +' Nothing here needs to change. Set the target higher if you want to see what the next step costs.</p></div>';
  } else {
    box.innerHTML='<div class="pairgrid">'
      +'<div class="pcard"><span class="plbl">Charge this</span>'
      +'<span class="pnum num">'+money2(c.needPrice)+'</span>'
      +'<span class="psub">per service, at the '+c.vol+' a week you already do.</span>'
      +'<span class="pfine">That’s '+money2(c.needPrice-c.cur)+' more than the '+money(c.cur)+' you charge now.</span></div>'
      +'<div class="orbar"><i></i><span>or</span><i></i></div>'
      +'<div class="pcard"><span class="plbl">Wax this many more</span>'
      +'<span class="pnum num">'+c.extraCeil+'</span>'
      +'<span class="psub">extra clients a week, staying at '+money(c.cur)+'.</span>'
      +'<span class="pfine">Exactly '+dec2(c.extraExact)+' a week — rounded up, because you can’t book part of a person.</span></div>'
      +'</div>';
  }
  renderMath2(c);
  return c;
}

/* ══ TIE-IN ══════════════════════════════════════════════════ */
function renderTieIn(){
  $('#tiein-copy').textContent=CONFIG.tieIn.line||'';
  var a=$('#tiein-link');
  a.textContent=CONFIG.tieIn.linkText||'';
  a.hidden=!(CONFIG.tieIn.linkText&&CONFIG.tieIn.linkUrl);
}

/* ══ KIT ═════════════════════════════════════════════════════ */
function kitContext(){
  var p=currentPreset(), d=CONFIG.datePlaceholder;
  var ctx={service:p.name,date:d,note:''};
  if(state.tab===1){
    var c=computeT1();
    ctx.tabLabel='Can I raise?'; ctx.ready=c.ready;
    ctx.from=c.ready?money(c.cur):'[your price now]';
    ctx.to=c.ready?money(c.prop):'[your new price]';
    ctx.chip=c.ready?money(c.cur)+' → '+money(c.prop):'add your numbers';
  } else {
    var t=computeT2(), t1=computeT1();
    ctx.tabLabel='Hit a number'; ctx.ready=t.ready;
    ctx.from=t.ready?money(t.cur):'[your price now]';
    if(t.ready&&!t.alreadyThere){
      var rounded=Math.ceil(t.needPrice);
      ctx.to=money(rounded);
      ctx.chip=money(t.cur)+' → '+money(rounded);
      ctx.note='The exact price that hits '+money(t.tgt)+' is '+money2(t.needPrice)
        +' — the scripts round it up to '+money(rounded)+', because nobody posts a price with cents.';
    } else if(t.ready&&t.alreadyThere){
      ctx.to=t1.ready?money(t1.prop):'[your new price]';
      ctx.chip='target already covered';
      ctx.note='Your target is already covered, so these use the raise from Tab 1'
        +(t1.ready?' ('+money(t1.cur)+' → '+money(t1.prop)+')':'')+'.';
    } else { ctx.to='[your new price]'; ctx.chip='add your numbers'; }
  }

  /* If the price she'd be posting sits above the top of her local spread,
     the kit swaps announcement scripts for value-framing ones. */
  var mk=computeMarket(), t1m=computeT1();
  ctx.market=mk;
  var judged=ok(t1m.prop)?t1m.prop:t1m.cur;
  ctx.marketBand=pricePos(judged,mk);
  ctx.aboveMarket=(ctx.marketBand==='above');
  if(ctx.aboveMarket){
    ctx.tabLabel='Above your area’s range';
    ctx.chip='your area’s range is '+money(mk.low)+'–'+money(mk.high);
    // NB: must not say what people near that ZIP "usually pay" — that is a
    // competitor-price claim and we have no such data (contract E3).
    ctx.note='These scripts are for explaining your price, not announcing a change — because '+ctx.to
      +' is over the '+money(mk.high)+' top of the range for ZIP '+mk.zip+'.';
  }
  return ctx;
}

function scripts(ctx){ return ctx.aboveMarket ? valueScripts(ctx) : announcementScripts(ctx); }

/* Shown when her price sits above the top of the local spread. The job
   isn't to announce a change — it's to answer "why are you more than
   the place down the road?" without apologizing or discounting. */
function valueScripts(ctx){
  var s=ctx.service, price=ctx.to;
  return [
    { id:'booking', name:'Why your booking page says what it says',
      first:'Why '+s+' is '+price+' here.',
      rest:'\n\nYou get the whole appointment, not a slot someone is trying to run you out of. '
        +'And you get someone who has done this enough times to be quick about it.'
        +'\n\n[One line about what you actually do differently. The wax you use, the room, '
        +'how you book. Make it something true for you.]'
        +'\n\nThere are cheaper waxes in town. There always are. This is what mine costs.' },
    { id:'chair', name:'When she says “the place down the road is cheaper”',
      first:'Don’t defend the price. Compare the service, then stop talking.',
      rest:'\n\n“They are cheaper, you’re right. It’s not quite the same appointment though. '
        +'[Say the one true thing you do that they don’t.]'
        +'\n\nIf the price is the deciding thing, I genuinely won’t be offended. I’d just rather be the one you don’t have to think about.”'
        +'\n\nThen stop. Do not offer a discount to fill the silence. That teaches her the price was never real.' },
    { id:'post', name:'Instagram or text post',
      first:'I’m not the cheapest wax in town. That’s on purpose.',
      rest:'\n\nWhat '+price+' buys: an appointment that starts on time, and someone fast enough '
        +'that you’re not lying there wondering how much longer.'
        +'\n\n[Add the thing you’d want a new client to know before she books.]'
        +'\n\nIf cheapest is what you need right now, that’s completely fair. Go get waxed, I mean it. '
        +'If you’d rather not gamble on it, I’m here.' }
  ];
}

/* Service names are used as menu labels ("the price for Brows", "Brows: $30")
   rather than bare subjects, so every preset name stays grammatical. */
function announcementScripts(ctx){
  var s=ctx.service, d=ctx.date;
  return [
    { id:'booking', name:'Booking-page blurb',
      first:'Heads up, loves: new pricing from '+d+'. '+s+' goes to '+ctx.to+'.',
      rest:'\n\nSame room, same appointment length, same me, at a price that matches the work. '
        +'Anything already on the books before '+d+' stays at '+ctx.from+'. See you soon.' },
    { id:'chair', name:'What you say in the chair',
      first:'While I get you set up, quick heads up so nothing surprises you at checkout.',
      rest:'\n\n“From '+d+', the price for '+s+' goes to '+ctx.to+'. Today is still '+ctx.from+', '
        +'and I wanted you to hear it from me rather than from the card reader. Want me to book your next one now?”'
        +'\n\nThen stop talking. Don’t apologize, don’t explain your rent. The next person to speak is her.' },
    { id:'post', name:'Instagram or text post',
      first:'New rate, same hands. From '+d+', the price for '+s+' is '+ctx.to+'.',
      rest:'\n\nWhat hasn’t changed: the room, the wax, the time I hold for you, and the fact that I know exactly how you like it.'
        +'\n\nWhat has: everything it costs me to keep that room open.'
        +'\n\nBooking link in bio. Appointments made before '+d+' stay at '+ctx.from+'.' }
  ];
}

function renderKit(){
  var ctx=kitContext(), sc=scripts(ctx);
  $('#kit-for').innerHTML='Personalized for <b>'+esc(ctx.tabLabel)+'</b> · '
    +esc(ctx.service)+', <b>'+esc(ctx.chip)+'</b>';
  $('#kit-h').textContent = ctx.aboveMarket
    ? 'Email me my “why I’m worth it” scripts' : (CONFIG.kit.heading || 'Email me my price increase scripts');
  $('#kit-sub').textContent = ctx.aboveMarket
    ? 'You’re priced above your area, so these answer the question you’ll actually get asked: why you and not the cheaper place. One for your booking page, one for the chair, one for the feed.'
    : (CONFIG.kit.subheading || 'Three things to say, already written, with your numbers in them: the blurb for your booking page, the sentence you say in the chair, and the post.');

  var html='';
  for(var i=0;i<sc.length;i++){
    var x=sc[i];
    if(state.submitted){
      html+='<div class="script"><div class="script-top"><span class="script-name">'+esc(x.name)+'</span>'
        +'<button class="copybtn" type="button" data-copy="'+x.id+'">Copy</button></div>'
        +'<div class="script-body" id="sc-'+x.id+'">'+esc(x.first+x.rest)+'</div>'
        +'<p class="copyfallback" id="cf-'+x.id+'"></p></div>';
    } else {
      html+='<div class="script"><div class="script-top"><span class="script-name">'+esc(x.name)+'</span></div>'
        +'<div class="script-body locked">'+esc(x.first)
        +'<span class="redact" aria-hidden="true"><i style="width:96%"></i><i style="width:88%"></i><i style="width:54%"></i></span>'
        +'<span class="lockedtag">Full script comes with the kit</span></div></div>';
    }
  }
  $('#scripts').innerHTML=html;

  if(ctx.note) $('#kit-for').insertAdjacentHTML('afterend','<p class="kitnote" id="kit-note">'+esc(ctx.note)+'</p>');

  $('#kit-form').hidden=state.submitted;
  var sendBtn=$('#kit-form') && $('#kit-form').querySelector('button[type=submit]');
  if(sendBtn){
    sendBtn.disabled=state.sending;
    if(state.sending){ sendBtn.setAttribute('aria-busy','true'); sendBtn.textContent='Sending\u2026'; }
    else { sendBtn.removeAttribute('aria-busy'); sendBtn.textContent=CONFIG.kit.cta||sendBtn.textContent; }
  }
  $('#email-hint').textContent=state.emailErr;

  var sent=$('#kit-sent');
  sent.hidden=!state.submitted;
  if(state.submitted){
    sent.innerHTML='<div class="sent"><b>Your scripts are ready.</b>'
      +(state.emailed
        ? '<p>They\u2019re on their way to '+esc(state.email)+' too. Scroll up — they\u2019re filled in with your numbers.</p>'
        : '<p>'+esc(state.sendNote||'Scroll up — they\u2019re filled in with your numbers.')+'</p>')
      +'</div>'
      +'<div style="margin-top:14px"><button class="btn btn-ghost" type="button" id="kit-reset">\u2190 Back to the locked preview</button></div>';
  }
}

/* clipboard with a select-the-text fallback */
function copyScript(id,btn){
  var el=ROOT.querySelector('#sc-'+id), fb=ROOT.querySelector('#cf-'+id);
  if(!el) return;
  var text=el.textContent;
  function flash(label,st){
    btn.textContent=label;
    btn.setAttribute('data-state',st||'');
    setTimeout(function(){ btn.textContent='Copy'; btn.removeAttribute('data-state'); },1800);
  }
  function fallback(){
    try{
      var r=document.createRange();
      r.selectNodeContents(el);
      var sel=window.getSelection();
      sel.removeAllRanges(); sel.addRange(r);
      try{ if(document.execCommand('copy')){ if(fb) fb.textContent=''; flash('Copied','ok'); return; } }catch(e2){}
      if(fb) fb.textContent='Copying is blocked here — the text is selected for you, so hit ⌘C or Ctrl+C.';
      flash('Selected');
    }catch(e3){
      if(fb) fb.textContent='Copying is blocked here — select the text above and hit ⌘C or Ctrl+C.';
      flash('Select it');
    }
  }
  try{
    if(navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(text).then(function(){
        if(fb) fb.textContent=''; flash('Copied','ok');
      })['catch'](fallback);
    } else fallback();
  }catch(e){ fallback(); }
}

/* ══ TABS / THEME / RENDER ═══════════════════════════════════ */
function setTab(n){
  state.tab=n;
  for(var i=1;i<=2;i++){
    var t=$('#tab-'+i), p=$('#panel-'+i), on=(i===n);
    t.setAttribute('aria-selected',on?'true':'false');
    t.tabIndex=on?0:-1;
    p.hidden=!on;
  }
  renderAll();
  if(n===1) requestAnimationFrame(function(){ drawChart(computeT1()); });
}
function renderAll(){
  renderChips();
  if(state.tab===1) renderT1(); else renderT2();
  renderTieIn();
  var stale=ROOT.querySelector('#kit-note');
  if(stale) stale.remove();
  renderKit();
}

/* ══ SHOPIFY FORM BRIDGE ═════════════════════════════════════
   A Shopify Form sits off-screen in .prs-formhost. Her button fills it and
   clicks its submit; Forms creates the customer, writes the metafields,
   records marketing consent and adds the tag. She never sees a form.
   Every technique below was verified against the live form 12 Aug 2026 —
   see capture-worker/PAGE-INTEGRATION.md. Do not re-derive it. */
var PRS_FORM = (function(){
  /* The embed is a custom element with an OPEN shadow root, so the real
     inputs are reachable. */
  function root(){
    var host=document.querySelector('shopify-forms-embed');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }
  /* Fields are named "custom#<key>" — sometimes on id, sometimes on name,
     depending on the field type. Try both. */
  function field(r,key){
    return r.querySelector('[id="custom#'+key+'"]')
        || r.querySelector('[name="custom#'+key+'"]');
  }
  /* Assigning .value is ignored by the component's internal tracker. Go
     through the native setter, then fire the events it listens for. */
  function setValue(el,value){
    if(!el) return false;
    var proto = (typeof HTMLTextAreaElement!=='undefined' && el instanceof HTMLTextAreaElement)
      ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto,'value').set.call(el, value==null?'':String(value));
    el.dispatchEvent(new Event('input', {bubbles:true, composed:true}));
    el.dispatchEvent(new Event('change',{bubbles:true, composed:true}));
    return true;
  }
  /* Everything the calculator writes is a custom# field, so the one checkbox
     that is not is Shopify's marketing opt-in. */
  function consentBox(r){
    var boxes=r.querySelectorAll('input[type=checkbox]');
    for(var i=0;i<boxes.length;i++){
      if((boxes[i].name||'').indexOf('custom#')!==0) return boxes[i];
    }
    return null;
  }
  /* Resolves {ok, reason} and never rejects: a capture failure must not stop
     her getting her scripts. */
  function submit(values, consented){
    return new Promise(function(resolve){
      var r=root();
      if(!r) return resolve({ok:false, reason:'form_not_loaded'});

      var email=r.querySelector('#email')||r.querySelector('input[type=email]');
      if(!setValue(email, values.email)) return resolve({ok:false, reason:'no_email_field'});

      var missing=[];
      Object.keys(values.fields).forEach(function(key){
        var el=field(r,key);
        if(!el){ missing.push(key); return; }
        setValue(el, values.fields[key]);
      });

      /* Only ever mirror a tick she actually made. Never set this ourselves —
         it is the consent record that makes the subscription lawful. */
      var box=consentBox(r);
      if(box && consented && !box.checked) box.click();
      if(box && !consented) return resolve({ok:false, reason:'no_consent'});

      var btn=r.querySelector('button[type=submit], input[type=submit]');
      if(!btn) return resolve({ok:false, reason:'no_submit_button', missing:missing});

      /* The host carries `inert` so a keyboard user never tabs into a hidden
         form (aria-hidden alone would leave focusable descendants, which is the
         ARIA violation). inert does not block a programmatic .click(), but the
         documented submit path was verified without it, so lift it for the
         duration rather than rely on that. */
      var host=document.querySelector('.prs-formhost');
      var wasInert=!!(host && host.hasAttribute('inert'));
      if(wasInert) host.removeAttribute('inert');
      function restore(){ if(wasInert && host) host.setAttribute('inert',''); }

      /* Forms publishes no documented "submitted" event, so watch for the form
         being replaced by its success state. */
      var done=false;
      var observer=new MutationObserver(function(){
        if(done) return;
        if(!r.querySelector('button[type=submit]')){
          done=true; observer.disconnect(); restore(); resolve({ok:true, missing:missing});
        }
      });
      observer.observe(r,{childList:true, subtree:true});
      setTimeout(function(){
        if(done) return;
        done=true; observer.disconnect(); restore();
        /* Unknown rather than failed — it may well have gone through. */
        resolve({ok:false, reason:'timeout', missing:missing});
      },9000);

      btn.click();
    });
  }
  return { submit:submit, root:root };
})();

/* What the form is sent. Nothing is calculated here that the page has not
   already worked out. Prices go as bare numbers with no dollar sign — the
   email template prepends the $, so a sign here would render "$$75". */
function capturePayload(email){
  var ctx=kitContext(), c=computeT1(), mk=ctx.market||{}, sc=scripts(ctx);
  function body(id){
    for(var i=0;i<sc.length;i++) if(sc[i].id===id) return sc[i].first+sc[i].rest;
    return '';
  }
  /* Keeps cents when there are cents ("67.50") and stays clean when there are
     not ("65"). A Number form field rounded 67.50 to 68 in testing, which is
     why every field on the form is text. */
  function plain(n){
    if(n==null||!isFinite(n)) return '';
    return (n%1===0) ? String(n) : n.toFixed(2);
  }
  return {
    email: email,
    fields: {
      service:           ctx.service||'',
      current_price:     plain(c.okCur?c.cur:null),
      proposed_price:    plain(c.ready?c.prop:null),
      clients_per_week:  plain(c.okVol?c.vol:null),
      client_zip:        mk.found?mk.zip:'',
      normal_price_low:  mk.found?String(Math.round(mk.low)):'',
      normal_price_high: mk.found?String(Math.round(mk.high)):'',
      vs_normal:         ctx.marketBand||'',
      script_set:        ctx.aboveMarket?'value-framing':'announcement',
      script_booking:    body('booking'),
      script_chair:      body('chair'),
      script_post:       body('post')
    }
  };
}

/* ══ EVENTS ══════════════════════════════════════════════════ */
$('#chips').addEventListener('click',function(e){
  var b=e.target.closest('[data-preset]');
  if(b) applyPreset(b.getAttribute('data-preset'));
});
['#f-current','#f-volume','#f-proposed','#f-target','#f-area'].forEach(function(sel){
  $(sel).addEventListener('input',function(){ renderAll(); });
});
$('#mkt-clear').addEventListener('click',function(){ $('#f-area').value=''; renderAll(); $('#f-area').focus(); });
$('#f-t2current').addEventListener('input',function(){ state.t2Dirty.current=true; renderAll(); });
$('#f-t2volume').addEventListener('input', function(){ state.t2Dirty.volume=true;  renderAll(); });
$('#panel-2').addEventListener('click',function(e){
  var b=e.target.closest('[data-reinherit]');
  if(!b) return;
  state.t2Dirty[b.getAttribute('data-reinherit')]=false;
  renderAll();
});
$('#loss').addEventListener('touchmove',function(e){ e.stopPropagation(); },{passive:true});
$('#loss').addEventListener('input',function(e){
  state.loss=Number(e.target.value);   // synchronous — lands in this frame
  updateSlider();
});
$('#tab-1').addEventListener('click',function(){ setTab(1); });
$('#tab-2').addEventListener('click',function(){ setTab(2); });
$('.tablist').addEventListener('keydown',function(e){
  if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft'&&e.key!=='Home'&&e.key!=='End') return;
  e.preventDefault();
  var next=(e.key==='Home')?1:(e.key==='End')?2:(state.tab===1?2:1);
  setTab(next); $('#tab-'+next).focus();
});
$('#kit-form').addEventListener('submit',function(e){
  e.preventDefault();
  if(state.sending) return;
  var v=$('#f-email').value.trim();
  if(v==='') state.emailErr='Pop your email in first.';
  else if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) state.emailErr='That doesn’t look like an email address. Check it and try again.';
  else if(!$('#f-consent').checked) state.emailErr='Tick the box so we can email them to you.';
  else state.emailErr='';
  $('#f-email').setAttribute('aria-invalid',state.emailErr?'true':'false');
  if(state.emailErr){ renderAll(); $('#f-email').focus(); return; }

  state.email=v; state.sending=true; renderAll();

  /* She has already done the work — the email is the convenience. Show the
     scripts either way and say so if the send did not happen. */
  PRS_FORM.submit(capturePayload(v), true).then(function(res){
    state.sending=false;
    state.submitted=true;
    state.emailed=!!res.ok;
    state.sendNote = res.ok ? '' :
      'We couldn’t send the email just now. Your scripts are right here — copy them before you go.';
    if(!res.ok && window.console && console.warn) console.warn('[price tool] capture failed:', res);
    renderAll();
  });
});
$('.kit').addEventListener('click',function(e){
  var cp=e.target.closest('[data-copy]');
  if(cp){ copyScript(cp.getAttribute('data-copy'),cp); return; }
  if(e.target.id==='kit-reset'){ state.submitted=false; state.emailErr='';
    state.emailed=false; state.sendNote=''; renderAll(); }
});
if(window.ResizeObserver){
  new ResizeObserver(function(){ if(state.tab===1) drawChart(computeT1()); }).observe($('#chart'));
} else {
  window.addEventListener('resize',function(){ if(state.tab===1) drawChart(computeT1()); });
}

/* ══ BOOT — Brazilian preset, populated, no blank first paint ═ */
(function boot(){
  $('#f-target').value=String(CONFIG.defaultTarget);
  applyPreset(CONFIG.presets[0].key);
  requestAnimationFrame(function(){ if(state.tab===1) drawChart(computeT1()); });
})();

})();